<!-- Modal Wrapper -->
<div class="fixed inset-0 bg-black/50 z-50 flex items-center justify-center overflow-y-auto px-4 py-8">

  <!-- Modal Content -->
  <div class="relative w-full max-w-4xl bg-white rounded-lg shadow-xl overflow-hidden">

    <!-- Close Button -->
    <button
      (click)="closeModal()"
      class="absolute top-4 right-4 text-gray-600 hover:text-red-500 text-2xl z-10"
      aria-label="Close"
    >
      &times;
    </button>

    <!-- Main Modal Body -->
    <div class="p-6 md:p-10">

      <!-- Header -->
      <div class="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
        <div class="flex-1">
          <h2 class="text-2xl font-bold text-gray-900 mb-2">{{ item.supplier.name }}</h2>
          <div class="flex flex-wrap items-center gap-3 text-sm text-gray-600">
            <!-- Date -->
            <div class="flex items-center gap-1">
              <mat-icon class="text-gray-500 text-base">event</mat-icon>
              <span>{{ item.date | date: 'mediumDate' }} • {{ item.date | date: 'shortTime' }}</span>
            </div>

            <!-- Divider -->
            <span class="text-gray-300">|</span>

            <!-- Location -->
            <div class="flex items-center gap-1">
              <mat-icon class="text-gray-500 text-base">location_on</mat-icon>
              <span>{{ item.supplier.place }}</span>
            </div>

            <!-- Divider -->
            <span class="text-gray-300">|</span>

            <!-- Price -->
            <div class="flex items-center gap-1">
              <span class="text-xs">From</span>
              <span class="text-primary-500 font-semibold text-lg">
                {{ item.priceAdvertise | currency:item.currency:'symbol-narrow' }}
              </span>
            </div>
          </div>

          <!-- Short Description -->
          <div class="text-gray-600 text-sm mt-4" [innerHTML]="item.supplier.contentShort"></div>
        </div>
      </div>

      <!-- Tickets Section -->
      <div class="mt-10">
        <p class="text-lg font-semibold text-gray-800 mb-4">Ticket Options</p>

        <div class="space-y-6">
          <div
            *ngFor="let ticket of item.tickets"
            class="flex flex-col md:flex-row md:items-center justify-between gap-4 border-b border-gray-200 pb-4 last:border-b-0"
          >
            <!-- Ticket Category -->
            <div class="flex-1 min-w-0">
              <span class="text-gray-800 font-medium">{{ ticket.category }}</span>
            </div>

            <!-- Price & Stock -->
            <div class="flex items-center gap-4">
              <span class="text-gray-700 font-medium">
                $ {{ ticket.sell | number: '1.2-2' }}
              </span>
              <span
                [ngClass]="{
                  'bg-red-100 text-red-800': ticket.stock === 0,
                  'bg-green-100 text-green-800': ticket.stock > 5,
                  'bg-yellow-100 text-yellow-800': ticket.stock <= 5 && ticket.stock > 0,
                  'bg-pink-100 text-pink-800': ticket.stock <= 3 && ticket.stock > 0
                }"
                class="px-3 py-1 text-xs rounded-full"
              >
                {{ ticket.stock === 0 ? 'Sold out' : (ticket.stock + ' left') }}
              </span>
            </div>

            <!-- Actions -->
            <div class="flex gap-2 mt-2 md:mt-0">
              <button
                type="button"
                (click)="openSecondModal(ticket)"
                [disabled]="ticket.stock === 0"
                class="px-4 py-1 border-2 text-sm rounded-lg border-accent-500 hover:bg-primary-500 hover:border-primary-500 hover:text-white transition"
              >
                <span *ngIf="!isSubmitting">Enquire</span>
                <span *ngIf="isSubmitting">Sending...</span>
              </button>
              <button
                type="button"
                (click)="openMapModal(ticket)"
                class="px-4 py-1 border-2 text-sm rounded-lg border-accent-500 hover:bg-primary-500 hover:border-primary-500 hover:text-white transition"
              >
                View Seats
              </button>
            </div>
          </div>
        </div>
      </div>

    </div> <!-- End Modal Body -->
  </div>
</div>
